export default __webpack_public_path__ + "e7f06ef8eafa09a1ad2dab6192a74060.png";